import { render, staticRenderFns } from "./TaskSearchItem.vue?vue&type=template&id=db07d12e&"
import script from "./TaskSearchItem.vue?vue&type=script&lang=ts&"
export * from "./TaskSearchItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports